import isValueEmpty from 'hb-react/shared/utils/isValueEmpty';

export const errorMessage = __('Must be valid');

export const validateExcludeRegex = (
  value,
  excludeRegex,
  defaultErrorMessage = errorMessage,
) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  if (excludeRegex.test(value)) {
    error = defaultErrorMessage;
  }

  return error;
};
